<script setup lang="ts">
definePageMeta({
	name: 'articles.id',
	layout: 'article',
	title: 'Help',
});

const route = useRoute();
const { data: page } = await useAsyncData(route.path, () => {
	return queryCollection('content').path(route.path).first();
});

if (!page.value) {
	throw createError({ statusCode: 404 });
}

// The detail route resolves any article, published or not — only the listing and
// navigation queries filter on `published`. Unpublished articles are unlinked but
// still reachable by URL, so keep them out of the index.
useSeoMeta({
	robots: () => page.value?.published ? 'index, follow' : 'noindex, nofollow',
});
</script>

<template>
	<ArticleDetails :page="page" v-if="page" />
</template>
